"use client";

import Link from "next/link";
import React, { useRef } from "react";
import { useSetAtom } from "jotai";
import { aboutPanelVisibilityAtom } from "@/store";
import { Button, Alert, AlertDescription, AlertTitle } from "@oreme/ui";
import { ExternalLink, Info, X } from "lucide-react";
import { useTranslations } from "next-intl";

function SharedAboutPanel() {
  const t = useTranslations("about.AboutPanel");
  const toggleVisibility = useSetAtom(aboutPanelVisibilityAtom);

  const targetRef = useRef<HTMLDivElement>(null);

  const handleClose = () => toggleVisibility();

  return (
    <div
      className={`absolute 10 top-0 left-0 right-0 bottom-0 lg:top-1/2 lg:left-1/2 lg:ml-[28px] lg:-translate-x-1/2 lg:-translate-y-1/2 flex lg:rounded-lg bg-background border p-4 lg:shadow-lg lg:drop-shadow-lg flex-col gap-4 w-full lg:w-[480px] animate__animated animate__fadeIn animate__faster`}
      ref={targetRef}
    >
      <header className="flex flex-row justify-between items-center">
        <h2 className="font-semibold">{t("title")}</h2>
        <Button
          size="icon"
          onClick={handleClose}
          variant="ghost"
          title={t("close")}
        >
          <X size={16} />
        </Button>
      </header>
      <div className="overflow-y-scroll">
        <div className="flex flex-col gap-2 text-sm mb-4">
          <p className="text-foreground leading-tight">{t("text1")}</p>
          <p className="text-foreground leading-tight">{t("text2")}</p>
          <p className="text-foreground leading-tight">{t("text3")}</p>
        </div>
        <Alert>
          <AlertTitle className="flex flex-row items-center gap-2">
            <Info size={20} /> {t("warning.title")}
          </AlertTitle>
          <AlertDescription className="text-xs">
            {t("warning.description")}
          </AlertDescription>
        </Alert>
      </div>
      <footer className="flex flex-row mt-auto">
        <Button className="flex-1" variant="secondary" size="sm" asChild>
          <Link href="https://gpsmob.epos-france.fr/" target="_blank">
            {t("learnMore")} <ExternalLink size={16} />
          </Link>
        </Button>
      </footer>
    </div>
  );
}

export { SharedAboutPanel };
